import {injectLikertScaleSlotFallback} from '../../../incase-domain/elements/html/likertScaleSlotFallbackCss';
import {injectSequenceSlotFallback} from '../../../incase-domain/elements/html/sequenceSlotFallbackCss';
import {injectMultiselectSlotFallback} from '../../../incase-domain/elements/html/multiselectSlotFallbackCss';
import {injectQuestionSlotFallback} from '../../../incase-domain/elements/html/questionSlotFallbackCss';

export function injectHtmlSlotFallbacks(doc: Document): void {
    injectQuestionSlotFallback(doc);
    injectMultiselectSlotFallback(doc);
    injectSequenceSlotFallback(doc);
    injectLikertScaleSlotFallback(doc);
}
